import { useEffect, useState } from 'react';
import { useRouter } from 'next/router';

import { IconClose } from '@loadsmart/icons';

import { LangButton } from '@/components/LangButton';
import { getSuggestedLocale } from '@/helpers/detectBrowserLanguage';
import { getTranslationsForPath } from '@/datafiles/i18n/translatedPages';
import { LOCALES } from '@/datafiles/i18n/locales';

import {
  SuggestionTooltip,
  SuggestionArrow,
  SuggestionText,
  SuggestionLink,
  SuggestionClose,
} from './LanguageSuggestion.styles';

const LANG_SUGGESTION_DISMISS_KEY = 'lang-suggestion-dismissed';

export function LanguageSuggestion({ menuOpen = false }) {
  const router = useRouter();
  const [suggestedLocale, setSuggestedLocale] = useState(null);

  const dismissLanguageSuggestion = () => {
    sessionStorage.setItem(LANG_SUGGESTION_DISMISS_KEY, 'true');
    setSuggestedLocale(null);
  };

  useEffect(() => {
    const translations = getTranslationsForPath(router.asPath);
    const alreadyDismissed = sessionStorage.getItem(
      LANG_SUGGESTION_DISMISS_KEY
    );

    if (!translations || alreadyDismissed) {
      setSuggestedLocale(null);
      return;
    }

    setSuggestedLocale(
      getSuggestedLocale(
        Object.keys(translations.entry),
        translations.currentLocale
      )
    );
  }, [router.asPath]);

  // Opening the language menu counts as seeing the suggestion (same as opendock).
  useEffect(() => {
    if (menuOpen && suggestedLocale) dismissLanguageSuggestion();
  }, [menuOpen]); // eslint-disable-line react-hooks/exhaustive-deps

  if (!suggestedLocale) return null;

  const { entry } = getTranslationsForPath(router.asPath);
  const suggestedUrl = entry[suggestedLocale];
  const locale = LOCALES[suggestedLocale];

  return (
    <SuggestionTooltip>
      <SuggestionArrow />
      <SuggestionText
        as="a"
        href={suggestedUrl}
        onClick={dismissLanguageSuggestion}
      >
        {locale.suggestion}
      </SuggestionText>
      <SuggestionLink
        href={suggestedUrl}
        onClick={dismissLanguageSuggestion}
        aria-label={`Switch to ${locale.label}`}
      >
        <LangButton label={locale.flag} />
      </SuggestionLink>
      <SuggestionClose
        onClick={dismissLanguageSuggestion}
        aria-label="Dismiss suggestion"
      >
        <IconClose width="10" height="10" />
      </SuggestionClose>
    </SuggestionTooltip>
  );
}

export default LanguageSuggestion;
